export default __webpack_public_path__ + "static/100--stacked-column-4a92131a05805a44b0077e2424629d4b.png";